import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "main-icon__pictogram" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    title: _ctx.titleTooltip,
    class: _normalizeClass({ 'main-icon': true, 'main-icon--inactive': !this.active, 'main-icon--active': !!this.active}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click',$event)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.getContrastActive || !this.active)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "main-icon__pictogram__lc",
            src: _ctx.icon,
            alt: _ctx.icon
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "main-icon__pictogram__hc",
            src: _ctx.iconhc,
            alt: _ctx.iconhc
          }, null, 8, _hoisted_4))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
      'main-icon__text': true,
      'main-icon__text--inactive': !this.active,
    })
    }, _toDisplayString(_ctx.text), 3)
  ], 10, _hoisted_1))
}